import styles from "./BackToLoginPageButton.module.css";

import { Link } from "react-router-dom";


function BackToLoginPageButton() {

    return (
        <Link to="/login" className={styles.toLoginPage}>
            <svg
                className={styles.arrowIcon}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 6l-6 6l6 6" />
            </svg>
            <label className={styles.buttonLabel}>로그인 페이지로 돌아가기</label>
        </Link>
    );
}

export default BackToLoginPageButton;